import { useEffect, useRef } from "react";
import { input } from "../../helper";
import Question from "../Question";
import { TextField } from "../TextField";

export default function FillBlankCard({
  color = "",
  data,
  number,
  correctAnswer,
  setCorrectAnswer,
}) {
  const timer = useRef();
  useEffect(() => {
    setCorrectAnswer([]);
  }, [number]);

  const handleFillUp = (optionId, value) => {
    const blankIndex = correctAnswer.findIndex(
      (ans) => ans.blankId === optionId,
    );
    if (blankIndex >= 0) {
      correctAnswer[blankIndex].answer = value;
    } else {
      correctAnswer.push({ blankId: optionId, answer: value });
    }
    setCorrectAnswer([...correctAnswer]);
  };

  //Empty the input when a new question is rendered
  useEffect(() => {
    let inputs = document.querySelectorAll(".question-fields input");
    inputs.forEach((input) => {
      input.value = "";
    });
  }, [number]);

  return (
    <Question
      color={color}
      index={number}
      label={"Fill In The Blanks"}
      question={data}
    >
      {data.options.map((option, index) => (
        <TextField
          id={option.optionId}
          key={index}
          option={option}
          value={
            (correctAnswer || []).find((ans) => ans.blankId === option.optionId)
              ?.answer || ""
          }
          onChange={(value) => handleFillUp(option.optionId, value)}
          style={input(color)}
        />
        /*<textarea
          key={index}
          placeholder="Write your answer here"
          style={{ ...input(color) }}
          onChange={(e) => {
            handleFillUp(option.optionId, e.target.value);
          }}
        />*/
      ))}
    </Question>
  );
}
